<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

export default {
  computed: {
    theme() {
      return this.$store.state.app.theme
    }
  },
  created() {

  },
  mounted() {
  }
}
</script>
